// extracted by mini-css-extract-plugin
export var bookingText = "index-module--bookingText--3kFWz";
export var bookingTextLeft = "index-module--bookingTextLeft--751Rb";
export var container = "index-module--container--2ekzi";